var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 11.75C2.33579 11.75 2 12.0858 2 12.5C2 12.9142 2.33579 13.25 2.75 13.25H13.3445C13.6775 14.5439 14.8521 15.5 16.25 15.5C17.6479 15.5 18.8225 14.5439 19.1555 13.25H21.25C21.6642 13.25 22 12.9142 22 12.5C22 12.0858 21.6642 11.75 21.25 11.75H19.1555C18.8225 10.4561 17.6479 9.5 16.25 9.5C14.8521 9.5 13.6775 10.4561 13.3445 11.75H2.75ZM16.25 11C15.4216 11 14.75 11.6716 14.75 12.5C14.75 13.3284 15.4216 14 16.25 14C17.0784 14 17.75 13.3284 17.75 12.5C17.75 11.6716 17.0784 11 16.25 11Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9978 7C21.9978 6.58579 21.662 6.25 21.2478 6.25L10.1555 6.25C9.82245 4.95608 8.64788 4 7.25 4C5.85212 4 4.67755 4.95608 4.34451 6.25L2.7478 6.25C2.33359 6.25 1.9978 6.58579 1.9978 7C1.9978 7.41421 2.33359 7.75 2.7478 7.75L4.34451 7.75C4.67755 9.04392 5.85212 10 7.25 10C8.64788 10 9.82245 9.04392 10.1555 7.75L21.2478 7.75C21.662 7.75 21.9978 7.41421 21.9978 7ZM7.25 5.5C6.42157 5.5 5.75 6.17157 5.75 7C5.75 7.82843 6.42157 8.5 7.25 8.5C8.07843 8.5 8.75 7.82843 8.75 7C8.75 6.17157 8.07843 5.5 7.25 5.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9978 18C21.9978 17.5858 21.662 17.25 21.2478 17.25L12.1533 17.25C11.8203 15.9561 10.6457 15 9.2478 15C7.84786 15 6.67189 15.9532 6.34085 17.25H2.7478C2.33359 17.25 1.9978 17.5858 1.9978 18C1.9978 18.4142 2.33359 18.75 2.7478 18.75H6.34085C6.67189 20.0468 7.84786 21 9.2478 21C10.6457 21 11.8203 20.0439 12.1533 18.75L21.2478 18.75C21.662 18.75 21.9978 18.4142 21.9978 18ZM9.2478 16.5C8.41938 16.5 7.7478 17.1716 7.7478 18C7.7478 18.8284 8.41938 19.5 9.2478 19.5C10.0762 19.5 10.7478 18.8284 10.7478 18C10.7478 17.1716 10.0762 16.5 9.2478 16.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.54217049e96373dd3aa9a6e4abd944d4.svg";
export { ForwardRef as ReactComponent };